import type { Passkey } from 'models';
import { useTranslation } from 'react-i18next';
import { Button, Col, Delete2LineIcon, Flex, Row, Text } from 'ui';

type P = {
  onDelete: (passkey: Passkey) => void;
  passkey: Passkey;
};

const PasskeyItem = ({ onDelete, passkey }: P) => {
  const { t } = useTranslation();

  return (
    <Row align="middle" className="passkey-item" justify="space-between">
      <Col>
        <Flex vertical>
          <Text type="title" weight="bold">
            {passkey.name}
          </Text>
          <Text type="secondary">
            {t('Updated')}:{' '}
            {t('dateFormats.dateTime', {
              date: new Date(passkey.updatedAt),
            })}
          </Text>
        </Flex>
      </Col>
      <Col>
        <Flex justify="end">
          <Button
            danger
            icon={<Delete2LineIcon />}
            onClick={() => {
              onDelete(passkey);
            }}
            type="link-primary"
          />
        </Flex>
      </Col>
    </Row>
  );
};

export default PasskeyItem;
